import React from 'react'
import { ContainerLoading } from './styles'
import { SideModal } from '~/components/shared'
import { PortalModal } from '~/components/shared/PortalModal'
import { SpinnerIconLoader } from '~/components/shared/spinnerIconLoader'
import { IconComponent } from '~/assets/icons/component'

type ViewType = 'BigModal' | 'SideModal'

export type IHealthProcedureDetailsProps = React.PropsWithChildren<{
  showModal: boolean
  setShowModal: (newState: boolean) => void
  isLoading?: boolean
  viewType: ViewType
}>

export const HealthProcedureDetails: React.FC<IHealthProcedureDetailsProps> = ({
  showModal,
  setShowModal,
  viewType,
  isLoading,
  children
}: IHealthProcedureDetailsProps): JSX.Element => {
  return (
    <>
      {viewType === 'BigModal' && (
        <PortalModal show={showModal} onClose={() => setShowModal(false)} size={'big'} customWidth={1175}>
          {isLoading ? (
            <ContainerLoading>
              <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
            </ContainerLoading>
          ) : (
            children
          )}
        </PortalModal>
      )}
      {viewType === 'SideModal' && (
        <SideModal openSlideModal={showModal} setOpenSlideModal={setShowModal}>
          {isLoading ? (
            <ContainerLoading>
              <SpinnerIconLoader iconComponent={<IconComponent name={'loading'} />} size={75} velocity={2} />
            </ContainerLoading>
          ) : (
            children
          )}
        </SideModal>
      )}
    </>
  )
}
